'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserPage = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = require('react-apollo');

var _View = require('./View');

var _View2 = _interopRequireDefault(_View);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _connector = require('@prisma-cms/connector');

var _connector2 = _interopRequireDefault(_connector);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UserPage = exports.UserPage = (_temp = _class = function (_Page) {
  _inherits(UserPage, _Page);

  function UserPage() {
    _classCallCheck(this, UserPage);

    return _possibleConstructorReturn(this, (UserPage.__proto__ || Object.getPrototypeOf(UserPage)).apply(this, arguments));
  }

  _createClass(UserPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          View = _props.View,
          other = _objectWithoutProperties(_props, ['View']);

      return _get(UserPage.prototype.__proto__ || Object.getPrototypeOf(UserPage.prototype), 'render', this).call(this, _react2.default.createElement(View, other));
    }
  }]);

  return UserPage;
}(_layout2.default), _class.propTypes = _extends({}, _layout2.default.propTypes, {
  match: _propTypes2.default.object.isRequired,
  View: _propTypes2.default.func.isRequired
}), _class.defaultProps = _extends({}, _layout2.default.defaultProps, {
  View: _View2.default
}), _temp);
var UserPageConnector = (_temp2 = _class2 = function (_PrismaCmsConnector) {
  _inherits(UserPageConnector, _PrismaCmsConnector);

  function UserPageConnector() {
    _classCallCheck(this, UserPageConnector);

    return _possibleConstructorReturn(this, (UserPageConnector.__proto__ || Object.getPrototypeOf(UserPageConnector)).apply(this, arguments));
  }

  _createClass(UserPageConnector, [{
    key: 'prepareQuery',
    value: function prepareQuery() {
      var _ref = this.context.query || {},
          _ref$user = _ref.user,
          user = _ref$user === undefined ? '\n        query user (\n          $where: UserWhereUniqueInput!\n        ){\n          object: user (\n            where: $where\n          ){\n            id\n            username\n            fullname\n            email\n            phone\n            showEmail\n            showPhone\n            sudo\n            hasEmail\n            hasPhone\n          }\n        }\n      ' : _ref$user,
          _ref$updateUserProces = _ref.updateUserProcessor,
          updateUserProcessor = _ref$updateUserProces === undefined ? '\n        mutation updateUserProcessor(\n          $data: UserUpdateInput!\n          $where: UserWhereUniqueInput\n        ) {\n          response: updateUserProcessor(\n            data: $data\n            where: $where\n          ){\n            success\n            message\n            errors{\n              key\n              message\n            }\n            data{\n              id\n              username\n              fullname\n              email\n              phone\n              showEmail\n              showPhone\n              sudo\n              hasEmail\n              hasPhone\n            }\n          }\n        }\n      ' : _ref$updateUserProces;

      var View = this.props.View;
      return (0, _reactApollo.compose)((0, _reactApollo.graphql)((0, _graphqlTag2.default)(user), {// name: 'user', 
      }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateUserProcessor), {// name: 'updateUser', 
      }))(View);
    }
  }]);

  return UserPageConnector;
}(_connector2.default), _class2.propTypes = _extends({}, _connector2.default.propTypes, {
  View: _propTypes2.default.func.isRequired
}), _class2.defaultProps = _extends({}, _connector2.default.defaultProps, {
  View: UserPage
}), _temp2);
exports.default = UserPageConnector;